const ACCESS_KEY = 'platformAccessToken';
const REFRESH_KEY = 'platformRefreshToken';
const ROLE_KEY = 'platformRole';
const TENANT_RETURN_KEY = 'platformTenantReturn';

export const getPlatformToken = () => window.localStorage.getItem(ACCESS_KEY);

export const savePlatformSession = ({ access_token, refresh_token, platform_role }) => {
  window.localStorage.setItem(ACCESS_KEY, access_token);
  if (refresh_token) window.localStorage.setItem(REFRESH_KEY, refresh_token);
  if (platform_role) window.localStorage.setItem(ROLE_KEY, platform_role);
};

export const clearPlatformSession = () => {
  window.localStorage.removeItem(ACCESS_KEY);
  window.localStorage.removeItem(REFRESH_KEY);
  window.localStorage.removeItem(ROLE_KEY);
  window.localStorage.removeItem(TENANT_RETURN_KEY);
  window.sessionStorage.removeItem(TENANT_RETURN_KEY);
};

export const clearPlatformCredentials = () => {
  window.localStorage.removeItem(ACCESS_KEY);
  window.localStorage.removeItem(REFRESH_KEY);
  window.localStorage.removeItem(ROLE_KEY);
};

export const getPlatformRole = () => window.localStorage.getItem(ROLE_KEY);

export const savePlatformTenantReturn = (provider) => {
  if (!getPlatformToken() || !provider) return false;
  window.localStorage.removeItem(TENANT_RETURN_KEY);
  window.sessionStorage.setItem(TENANT_RETURN_KEY, provider);
  return true;
};

export const hasPlatformTenantReturn = (provider) => Boolean(
  provider && window.sessionStorage.getItem(TENANT_RETURN_KEY) === provider
);

export const clearPlatformTenantReturn = () => {
  window.localStorage.removeItem(TENANT_RETURN_KEY);
  window.sessionStorage.removeItem(TENANT_RETURN_KEY);
};

